export class ExamComputerBased {
    constructor(id, input) {
        this.id = id;
        this.input = input;
        input.on("change", () => this.synchronizeWithPartner());
    }
    get computerBased() {
        return this.input.is(":checked");
    }
    set computerBased(value) {
        this.input.prop("checked", value);
    }
    get ajaxObject() {
        return { id: this.id, computerBased: this.computerBased ? 1 : 0 };
    }
    synchronizeWithPartner() {
        if (this.partner === undefined ||
            this.partner.computerBased === this.computerBased) {
            return;
        }
        this.partner.computerBased = this.computerBased;
    }
}
